// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';

import { Grid } from '@xsolla/ui-core';

import { BabkaOauthSettings } from '../../api/configurations/babkaLogin/types';
import { LoginProjectData } from '../../api/dasboard/types';
import { BabkaLoginCard, CreateLoginButton, HelpSteps, LoginProjectCard } from '../../components';
import { PageHeader, Separator } from '../../components/ui';
import { useConfig } from '../../contexts/config';
import { useBabkaOauthModal } from '../../hooks/babkaLogin';

const LoginProjectsContent = styled.div`
  > * {
    grid-template-columns: calc(50% - 12px) calc(50% - 12px);
    gap: 24px !important; // half of the gap is subtracted from 50% in grid-template-columns
  }
`;

type Props = {
  loginProjects: Array<LoginProjectData>;
  babkaLoginClient: Array<BabkaOauthSettings> | null;
  showBabkaLogin: boolean;
} & RouteComponentProps;

const LoginProjects = ({
  history,
  location,
  loginProjects,
  babkaLoginClient,
  showBabkaLogin
}: Props): JSX.Element => {
  const intl = useIntl();
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    xsollaAnalytics.sendOpen('login_pa_module__dashboard', 'open', {
      type: 'projects_list'
    });
  }, []);

  const { openCreateModal } = useBabkaOauthModal({ history, location, showBabkaLogin });

  return (
    <>
      <PageHeader
        title={intl.formatMessage({ id: 'dashboard.label' })}
        extraButton={
          <CreateLoginButton babkaLoginProject={showBabkaLogin} openCreateModal={openCreateModal} />
        }
      />
      <LoginProjectsContent>
        <Grid cols={0} allowOverflow>
          {loginProjects.map((project) => (
            <LoginProjectCard
              projectId={project.id}
              name={project.name}
              key={project.id}
              dateChanged={project.updated_at}
              publisherProjectId={project.publisher_project_id}
            />
          ))}
          {showBabkaLogin &&
            babkaLoginClient &&
            babkaLoginClient.map((client) => <BabkaLoginCard key={client.id} client={client} />)}
        </Grid>
      </LoginProjectsContent>

      <Separator />

      <HelpSteps />
    </>
  );
};

export default withRouter(LoginProjects);
